/**
  Given a JSON object where the data values and headers have been split into separate key lookups, this function will combine the data values with the headers and returns one large array of objects.
  @param json A JSON data Object with `data` and `headers` keys.
  @param data The key in the JSON object that contains the data array.
  @param headers The key used for the flat headers array inside of the JSON object.
*/ export default function(json) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "data", headers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "headers";
    return json[data].map(function(row) {
        return json[headers].reduce(function(obj, header, i) {
            return obj[header] = row[i], obj;
        }, {});
    });
}

//# sourceMappingURL=fold.js.map